import PropTypes from 'prop-types';
import * as IconNames from '../../../resources/icons/generated/iconNames';
import {
  IconSvgPathsMajor,
  IconSvgPathsMicro,
  IconSvgPathsMinor,
} from '../../../resources/icons/generated/iconSvgPaths';
import * as IconSizes from '../iconSizes';

const SIZE_NAME_TO_SIZE = {
  major: 24,
  micro: 16,
  minor: 16,
};

const SIZE_NAME_TO_ICON_MAP = {
  major: IconSvgPathsMajor,
  minor: IconSvgPathsMinor,
  micro: IconSvgPathsMicro,
};

/**
 * Basic one-color Icon component in 3 standard sizes: Major (24x24 px), minor (16x16 px), and micro (8x8). Not every icon is configured for every size.
 */
function Icon(props) {
  const { classes, name, size, svgProps } = props;
  const key = Date.now();

  const pxSize = SIZE_NAME_TO_SIZE[size];
  const pathMap = SIZE_NAME_TO_ICON_MAP[size];
  const iconPath = pathMap[name];

  return !iconPath ? null : (
    <div className={`Icon Icon--size-${size} ${classes}`}>
      <svg key={`iconsvg-${key}`} height={pxSize} width={pxSize} {...svgProps}>
        {iconPath.map((path, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <path key={`iconpath-${i}-${key}`} d={path} />
        ))}
      </svg>
    </div>
  );
}

Icon.names = IconNames;
Icon.sizes = IconSizes;

Icon.defaultProps = {
  classes: null,
  size: 'minor',
  svgProps: {},
};

Icon.propTypes = {
  /**
   * A space-separated list of classes to apply to the `div` wrapping the icon's svg
   */
  classes: PropTypes.string,
  /**
   * Name of the icon to show
   */
  name: PropTypes.string.isRequired,

  /**
   * The size of the icon
   */
  size: PropTypes.oneOf(Object.keys(IconSizes)),

  /**
   * Props to be applied to the icon `svg`. Most commonly used to change the icon color as
   * follows: `{ style: { fill: iconColor } }`
   */
  // eslint-disable-next-line react/forbid-prop-types
  svgProps: PropTypes.object,
};

export default Icon;
